// Funnel analytics (client-reportable events only; purchases, checkout starts
// and first practice/exam are recorded server-side). Fire-and-forget: analytics
// must never break the experience.

import { getAnonymousId } from '@/lib/platform/storage';
import { supabase } from '@/lib/supabase/client';

export type ClientEvent =
  | 'site_visit'
  | 'store_impression'
  | 'store_search'
  | 'product_view'
  | 'preview_start'
  | 'preview_complete'
  | 'checkout_cancelled'
  | 'practice_start'
  | 'exam_submit';

const recent = new Map<string, number>();

export function track(event: ClientEvent, data: { productId?: string | null; bankId?: string | null; properties?: Record<string, unknown> } = {}) {
  // De-duplicate rapid repeats (React strict mode, re-renders).
  const key = `${event}:${data.productId ?? ''}:${data.bankId ?? ''}`;
  const now = Date.now();
  if ((recent.get(key) ?? 0) > now - 5000) return;
  recent.set(key, now);

  void (async () => {
    try {
      await supabase.rpc('track_event', {
        _event_type: event,
        _product_id: data.productId ?? null,
        _question_bank_id: data.bankId ?? null,
        _anonymous_id: await getAnonymousId(),
        _properties: data.properties ?? {},
      });
    } catch {
      /* ignore */
    }
  })();
}
